/**
 * Fellheimat - Paketschutz als dritte Produktoption des Geschirrs
 *
 * WARUM KEIN EIGENES PRODUKT
 * Eine Bestellposition ohne verbundenes CJ-Produkt schiebt bei CJ-Dropshipping
 * die GANZE Bestellung in "Invalid Orders" (CJ-Doku, 14.09.2026) - Handarbeit
 * je Bestellung, und die Position bleibt in Shopify ewig unerfuellt. Der
 * Schutz ist deshalb eine VARIANTE des Geschirrs: Option "Versand" mit den
 * Werten "Standard" (59,95) und "Mit Paketschutz (+2,95 EUR)" (62,90). Fuer CJ
 * ist das eine ganz normale Geschirr-Variante, die einmal verbunden wird.
 *
 * GENAU EINE SCHUTZ-VARIANTE JE BESTELLUNG ("2b", Betreiber 14.09.2026)
 * Die OBERSTE Geschirrzeile traegt die Schutz-Variante mit Menge 1, alle
 * weiteren Stuecke sind Standard. Hat die oberste Zeile Menge n > 1, wird sie
 * geteilt: 1x Schutz, (n-1)x Standard. Zwei Zeilen derselben Farbe/Groesse
 * sind bei CJ eine Position mehr - bewusst in Kauf genommen, selten.
 *
 * WAS DIESES SKRIPT TUT
 * 1. Add-to-Cart: Horizons eigener Request wird im fetch-Patch umgeschrieben.
 *    Liegt noch kein Schutz im Warenkorb und ist er gewuenscht, bekommt das
 *    Stueck, das oben landen wird, die Schutz-Variante plus die Property fuer
 *    den Checkout. Ein Request, der Drawer in der Antwort stimmt sofort.
 * 2. Schalter im Warenkorb (snippets/fh-shield-line): reconcile() baut die
 *    Geschirrzeilen um (add.js + change.js) und morpht die Warenkorb-Sections
 *    mit Horizons eigenem Renderer neu.
 * 3. Abgleich beim Laden und nach jedem Add-to-Cart: zeigt die Zeile einen
 *    anderen Zustand als gewuenscht (aelterer Warenkorb, nicht umschreibbarer
 *    Request), wird einmal nachgezogen.
 *
 * GEWUENSCHT IST, WAS DER KUNDE ZULETZT ENTSCHIEDEN HAT
 * localStorage "fh_shield" = on | off. Ohne Eintrag gilt die Voreinstellung
 * aus fh-shield-config. Wer den Schutz abwaehlt und danach ein zweites
 * Geschirr in den Warenkorb legt, bekommt es ohne Schutz - eine abgewaehlte
 * Zusatzleistung darf nicht durch die Hintertuer zurueckkommen.
 *
 * REIHENFOLGE DER FETCH-PATCHES
 * Dieses Skript wird als ERSTES geladen (snippets/stylesheets.liquid rendert
 * fh-shield-bridge vor fh-free-gift-config) und ist damit der innerste Patch:
 *     fh-volume-tiers.js -> fh-free-gift.js -> fh-shield.js -> fetch
 * Es sieht den fertigen Body inklusive der items[] der Mengenstaffel.
 * Gemessen (Fallstrick 45): der Warenkorb zeigt die items[] in UMGEKEHRTER
 * Anhaenge-Reihenfolge - das zuletzt angehaengte Stueck steht oben. Deshalb
 * bekommt das Stueck mit dem hoechsten items[N]-Index den Schutz, und ein
 * abgespaltenes Schutz-Stueck wird ganz hinten angehaengt.
 *
 * EIGENE SCHREIBVORGAENGE UND DAS GESCHENK-SKRIPT
 * fh-free-gift.js haengt an jeden Warenkorb-Schreibvorgang, der ueber
 * window.fetch laeuft, 200 ms spaeter ein reconcile(), das Properties per
 * change.js neu schreibt - und change.js mit Properties AENDERT DEN
 * ZEILENSCHLUESSEL. Liefe das mitten in unserem Umbau, faenden unsere
 * change.js-Aufrufe ihre Zeilen nicht mehr. Deshalb laufen alle Schritte bis
 * auf den letzten ueber nativeFetch; nur der letzte geht ueber window.fetch
 * und stoesst das Geschenk-reconcile genau einmal an - nach uns.
 */
(function () {
  'use strict';

  var CFG = window.FH_SHIELD || {};
  var PRODUCT_ID = CFG.productId;
  var ON_IDS = CFG.onIds || {};
  var PRESELECTED = !!CFG.preselected;
  var PROP = CFG.propertyKey || 'Paketschutz';
  var PROP_VALUE = CFG.propertyValue || '';
  var KEY = 'fh_shield';

  if (!PRODUCT_ID) return;

  var OFF_IDS = {};
  Object.keys(ON_IDS).forEach(function (offId) {
    OFF_IDS[String(ON_IDS[offId])] = offId;
  });

  var CART_ADD = /\/cart\/add(\.js)?/;
  var CART_CLEAR = /\/cart\/clear(\.js)?/;
  var nativeFetch = window.fetch.bind(window);

  /* --- Entscheidung des Kunden ---------------------------------------------- */

  function stored() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function store(value) {
    try {
      window.localStorage.setItem(KEY, value);
    } catch (e) {
      /* privater Modus - dann gilt je Seite die Voreinstellung */
    }
  }

  function wantOn() {
    var s = stored();
    if (s === 'on') return true;
    if (s === 'off') return false;
    return PRESELECTED;
  }

  function toOn(id) {
    var t = ON_IDS[String(id)];
    return t ? String(t) : null;
  }

  function toOff(id) {
    var t = OFF_IDS[String(id)];
    return t ? String(t) : null;
  }

  /* Zeigt der Warenkorb (Drawer oder Seite) gerade Schutz an? Die Zeile wird
     serverseitig aus dem Warenkorb gerendert und ist damit die Wahrheit. */
  function domState() {
    var row = document.querySelector('[data-fh-shield]');
    if (!row) return null;
    return row.dataset.state === 'on';
  }

  /* --- Add-to-Cart umschreiben ---------------------------------------------- */

  function rewriteForm(body) {
    if (!wantOn() || domState() === true) return;

    var slots = [];
    body.forEach(function (value, key) {
      var m = /^items\[(\d+)\]\[id\]$/.exec(key);
      if (m) slots.push(Number(m[1]));
    });

    if (slots.length) {
      /* Mengenstaffel: der hoechste Index landet oben im Warenkorb. */
      var top = Math.max.apply(null, slots);
      var id = body.get('items[' + top + '][id]');
      var mit = toOn(id);
      if (!mit) return;
      var qty = Number(body.get('items[' + top + '][quantity]')) || 1;
      if (qty === 1) {
        body.set('items[' + top + '][id]', mit);
        body.set('items[' + top + '][properties][' + PROP + ']', PROP_VALUE);
      } else {
        body.set('items[' + top + '][quantity]', String(qty - 1));
        var next = top + 1;
        body.append('items[' + next + '][id]', mit);
        body.append('items[' + next + '][quantity]', '1');
        body.append('items[' + next + '][properties][' + PROP + ']', PROP_VALUE);
      }
      return;
    }

    var single = body.get('id');
    var mitSingle = toOn(single);
    if (!mitSingle) return;
    var q = Number(body.get('quantity')) || 1;
    if (q === 1) {
      body.set('id', mitSingle);
      body.set('properties[' + PROP + ']', PROP_VALUE);
      return;
    }

    /* Menge > 1 aus dem Standard-Mengenwaehler: auf items[] umschreiben,
       quantity 0 oben haelt das id-Feld fuer Horizon am Leben (Fallstrick 44).
       Das Schutz-Stueck zuletzt, damit es oben steht (Fallstrick 45). */
    body.set('quantity', '0');
    body.append('items[0][id]', String(single));
    body.append('items[0][quantity]', String(q - 1));
    body.append('items[1][id]', mitSingle);
    body.append('items[1][quantity]', '1');
    body.append('items[1][properties][' + PROP + ']', PROP_VALUE);
  }

  function rewriteJson(init) {
    if (!wantOn() || domState() === true) return;
    var j = JSON.parse(init.body);
    var items = j.items && j.items.length ? j.items : j.id ? [j] : [];
    if (!items.length) return;
    /* Bei JSON-Bodies gilt die Reihenfolge des Arrays; das letzte Element
       landet oben. */
    var last = items[items.length - 1];
    var mit = toOn(last.id);
    if (!mit) return;
    var qty = Number(last.quantity) || 1;
    last.properties = last.properties || {};
    if (qty === 1) {
      last.id = mit;
      last.properties[PROP] = PROP_VALUE;
    } else {
      last.quantity = qty - 1;
      var extra = { id: mit, quantity: 1, properties: {} };
      extra.properties[PROP] = PROP_VALUE;
      if (j.items) j.items.push(extra);
      else j = { items: [last, extra] };
    }
    init.body = JSON.stringify(j);
  }

  function rewrite(input, init) {
    var body = (init && init.body) || (input && input.body);
    if (!body) return;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return rewriteForm(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return rewriteForm(body);
    if (typeof body === 'string' && init && typeof init === 'object') return rewriteJson(init);
  }

  /* --- Warenkorb umbauen ---------------------------------------------------- */

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function post(fetchFn, path, payload) {
    return fetchFn(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json();
    });
  }

  function sectionTargets() {
    var out = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var id = c.dataset.sectionId;
      if (!id) return;
      out.push({ id: id, mode: c.dataset.drawer !== undefined ? 'hydration' : 'full' });
    });
    return out;
  }

  /* Ersatzweg ohne Horizons Renderer: den Inhalt der cart-items-component
     durch den aus der Antwort ersetzen. Custom Elements darin werden vom
     Browser neu aufgebaut. */
  function replaceRaw(sections) {
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var html = sections && sections[c.dataset.sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-items-component');
      if (fresh) c.innerHTML = fresh.innerHTML;
    });
  }

  function morph(sections) {
    var targets = sectionTargets();
    return import('@theme/section-renderer')
      .then(function (m) {
        return Promise.all(
          targets.map(function (t) {
            var html = sections && sections[t.id];
            return html ? m.morphSection(t.id, html, { mode: t.mode }) : null;
          })
        );
      })
      .catch(function (e) {
        if (window.console) console.warn('[fh-shield] morph fehlgeschlagen, Ersatzweg:', e);
        replaceRaw(sections);
      });
  }

  function propsWithout(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k !== PROP) out[k] = props[k];
    });
    return out;
  }

  function propsWith(props) {
    var out = propsWithout(props);
    out[PROP] = PROP_VALUE;
    return out;
  }

  /**
   * Bringt den Warenkorb in den Zustand `on`:
   *   on  -> genau ein Schutz-Stueck, und zwar in der obersten Geschirrzeile
   *   off -> kein Schutz-Stueck
   * Loest sich zu null auf, wenn nichts zu tun war.
   */
  function reconcile(on) {
    return getCart().then(function (cart) {
      var lines = (cart.items || []).filter(function (item) {
        return String(item.product_id) === String(PRODUCT_ID);
      });
      if (!lines.length) return null;

      var adds = [];
      var changes = [];

      lines.forEach(function (line, index) {
        var isMit = !!toOff(line.variant_id);
        var isStd = !!toOn(line.variant_id);
        if (!isMit && !isStd) return;

        if (on && index === 0) {
          if (isMit && line.quantity > 1) {
            adds.push({ id: toOff(line.variant_id), quantity: line.quantity - 1, properties: propsWithout(line.properties) });
            changes.push({ key: line.key, variantId: String(line.variant_id), quantity: 1 });
          } else if (isStd) {
            adds.push({ id: toOn(line.variant_id), quantity: 1, properties: propsWith(line.properties) });
            changes.push({ key: line.key, variantId: String(line.variant_id), quantity: line.quantity - 1 });
          }
          return;
        }

        if (isMit) {
          adds.push({ id: toOff(line.variant_id), quantity: line.quantity, properties: propsWithout(line.properties) });
          changes.push({ key: line.key, variantId: String(line.variant_id), quantity: 0 });
        }
      });

      if (!adds.length && !changes.length) return null;

      var targets = sectionTargets();
      var sectionIds = targets
        .map(function (t) {
          return t.id;
        })
        .join(',');

      /* DER SCHLUESSEL EINER ZEILE IST FLUECHTIG. fh-free-gift.js schreibt
         200 ms nach jedem Warenkorb-Schreibvorgang Properties per change.js,
         und damit aendert sich der Schluessel (variant:hash). Ein change.js mit
         dem Schluessel von vor einer Sekunde trifft dann nichts mehr - gemessen
         am 14.09.2026 (dritte Zeile im Warenkorb, Schalter blieb aus). Deshalb
         wird der Schluessel unmittelbar vor jedem change.js aus einem frischen
         /cart.js aufgeloest: erst ueber den alten Schluessel, sonst ueber die
         Varianten-ID. Die neu hinzugefuegten Zeilen haben in allen drei Faellen
         eine andere Varianten-ID als die zu aendernde Zeile (Schutz gegen
         Standard), eine Verwechslung ist ausgeschlossen. */
      function resolveKey(change) {
        return getCart().then(function (fresh) {
          var items = fresh.items || [];
          var hit = null;
          items.forEach(function (item) {
            if (item.key === change.key) hit = item;
          });
          if (!hit) {
            items.forEach(function (item) {
              if (!hit && String(item.variant_id) === change.variantId) hit = item;
            });
          }
          return hit ? hit.key : null;
        });
      }

      function applyChange(change, lastStep, attempt) {
        return resolveKey(change).then(function (key) {
          if (!key) return null;
          var payload = { id: key, quantity: change.quantity };
          if (lastStep) {
            payload.sections = sectionIds;
            payload.sections_url = window.location.pathname;
          }
          return post(lastStep ? window.fetch : nativeFetch, '/cart/change.js', payload).then(function (res) {
            /* Shopify antwortet bei einem unbekannten Schluessel mit einem
               Fehlerobjekt statt mit dem Warenkorb. Einmal frisch nachsetzen. */
            if (res && !res.items && attempt < 1) return applyChange(change, lastStep, attempt + 1);
            return res;
          });
        });
      }

      /* Erst hinzufuegen, dann die alten Zeilen kuerzen - nie umgekehrt, sonst
         ist der Warenkorb zwischendurch leer und Horizon zeigt den Leerzustand.
         Alle Schritte bis auf den letzten ueber nativeFetch (siehe Kopf). */
      var chain = Promise.resolve();
      if (adds.length) {
        chain = chain.then(function () {
          return post(nativeFetch, '/cart/add.js', { items: adds });
        });
      }
      changes.forEach(function (change, i) {
        var lastStep = i === changes.length - 1;
        chain = chain.then(function () {
          return applyChange(change, lastStep, 0);
        });
      });

      return chain.then(function (res) {
        if (res && res.sections) return morph(res.sections).then(function () { return res; });
        return res;
      });
    });
  }

  /* Serialisiert eigene Umbauten - zwei parallele Umbauten wuerden sich
     gegenseitig die Zeilen wegnehmen. */
  var pending = Promise.resolve();
  function queue(task) {
    var run = pending.then(task, task);
    pending = run.catch(function () {});
    return run;
  }

  /* --- Schalter ------------------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-fh-shield-toggle')) return;

    var on = input.checked;
    store(on ? 'on' : 'off');

    var root = input.closest('[data-fh-shield]');
    if (root) root.classList.add('is-busy');

    queue(function () {
      return reconcile(on);
    })
      .catch(function (e) {
        if (window.console) console.warn('[fh-shield] Umbau fehlgeschlagen:', e);
        input.checked = !on;
        store(on ? 'off' : 'on');
      })
      .then(function () {
        if (root) root.classList.remove('is-busy');
      });
  });

  /* --- Abgleich: Anzeige gegen Wunsch ---------------------------------------- */

  function sync() {
    var shown = domState();
    if (shown === null) return;
    var on = wantOn();
    if (shown === on) return;
    queue(function () {
      return reconcile(on);
    });
  }

  /* --- fetch-Patch ---------------------------------------------------------- */

  window.fetch = function (input, init) {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (CART_ADD.test(url)) {
      try {
        rewrite(input, init);
      } catch (e) {
        /* Im Zweifel unveraendert weiterreichen; sync() holt den Zustand
           nach dem Rendern nach. */
      }
      var promise = nativeFetch.apply(null, args);
      promise
        .then(function () {
          /* Erst nach dem Geschenk-reconcile (200 ms + Laufzeit), sonst
             arbeiten beide gleichzeitig an denselben Zeilen. */
          setTimeout(sync, 1200);
        })
        .catch(function () {});
      return promise;
    }

    if (CART_CLEAR.test(url)) {
      /* /cart/clear.js rendert den Drawer nicht neu - die Zeile im DOM waere
         danach eine Luege ("Schutz vorhanden") und der naechste Add-to-Cart
         liesse den Tausch aus. Gemessen am 14.09.2026. Zeile entfernen, dann
         gilt "kein Geschirr im Warenkorb". */
      var clearing = nativeFetch.apply(null, args);
      clearing
        .then(function () {
          document.querySelectorAll('[data-fh-shield]').forEach(function (row) {
            row.remove();
          });
        })
        .catch(function () {});
      return clearing;
    }

    return nativeFetch.apply(null, args);
  };

  /* Beim Laden erst nach dem Geschenk-reconcile von fh-free-gift.js, das
     direkt bei DOMContentLoaded laeuft - sonst arbeiten beide gleichzeitig an
     denselben Zeilen. */
  function boot() {
    setTimeout(sync, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
